import { render, staticRenderFns } from "./EmailModeration.vue?vue&type=template&id=6074692d"
import script from "./EmailModeration.vue?vue&type=script&lang=js"
export * from "./EmailModeration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports